import * as React from 'react';

import PlusMinus from '../../shared/components/icons/PlusMinus';
import RenderMark from '../../shared/components/RenderMark';
import t from '../../shared/translations';
import { IOtherLearningMiles } from './MyHistory';
import { AccordionBody, AccordionContainer, AccordionHeader, AccordionHeading, SectionHeading } from './stylings';

interface IProps {
    otherMiles: IOtherLearningMiles[];
}

function OtherLearningMiles({ otherMiles }: IProps): JSX.Element {
    const [open, setOpen] = React.useState('');
    const toggle = (id: string) => {
        setOpen(currId => {
            if (currId === id) {
                return '';
            } else {
                return id;
            }
        });
    };
    if (otherMiles.length === 0) {
        return null;
    }
    return <section>
        <SectionHeading>{t('player.my-history.heading-other-awarded-miles')}</SectionHeading>
        <div>
            {otherMiles.map(om =>
                <AccordionContainer key={om.id}>
                    <AccordionHeader onClick={() => toggle(om.id)} $pointer={true}>
                        <AccordionHeading>{om.title}</AccordionHeading>
                        <div>{om.miles}</div>
                        <PlusMinus open={open === om.id} />
                    </AccordionHeader>
                    {open === om.id &&
                        <AccordionBody>
                            <div>
                                {t('player.my-history.label-date', { date: om.date })}
                            </div>
                            <RenderMark content={om.description} />
                        </AccordionBody>
                    }
                </AccordionContainer>,
            )}
        </div>
    </section>;
}

export default React.memo(OtherLearningMiles);
